import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="page-content">
        <button className="back-button" onClick={() => navigate('/')}>
          ← Back to Home
        </button>

        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: May 11, 2026</p>

        <section>
          <h2>Introduction</h2>
          <p>
            PhenoGuessr ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy
            explains how we collect, use, and safeguard information when you use our educational geography
            game at phenoguessr.party (the "Service").
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>

          <h3>Game Data</h3>
          <p>
            When you play PhenoGuessr, we temporarily store:
          </p>
          <ul>
            <li>Game IDs and phenotype selections</li>
            <li>Your guesses and scores</li>
            <li>Game completion status</li>
          </ul>
          <p>
            This data is stored temporarily to enable game functionality and is automatically deleted after
            30 days. We do not associate this data with any personal identifiers.
          </p>

          <h3>Automatically Collected Information</h3>
          <p>
            Like most websites, we automatically collect certain technical information:
          </p>
          <ul>
            <li>Browser type and version</li>
            <li>Device type and operating system</li>
            <li>IP address (anonymized)</li>
            <li>Pages visited and time spent</li>
            <li>Referring website</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul>
            <li>Provide and maintain the game functionality</li>
            <li>Improve user experience and game features</li>
            <li>Generate anonymous usage statistics</li>
            <li>Detect and prevent technical issues</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>Cookies and Tracking</h2>
          <p>
            PhenoGuessr uses minimal cookies and tracking technologies:
          </p>
          <ul>
            <li><strong>Essential Cookies:</strong> Required for basic game functionality</li>
            <li><strong>Analytics Cookies:</strong> Help us understand how players use the game (Google Analytics)</li>
            <li><strong>Advertising Cookies:</strong> Used by Google AdSense to display relevant ads</li>
          </ul>
          <p>
            You can control cookies through your browser settings. Note that disabling cookies may affect
            game functionality.
          </p>
        </section>

        <section>
          <h2>Third-Party Services</h2>

          <h3>Cloudflare</h3>
          <p>
            Our Service is hosted on Cloudflare Pages. Cloudflare may collect technical information for
            security and performance purposes. See Cloudflare's Privacy Policy for details.
          </p>

          <h3>Google AdSense</h3>
          <p>
            We use Google AdSense to display advertisements. Google may use cookies to serve ads based on
            your prior visits to our website or other websites. You can opt out of personalized advertising
            by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
            Google's Ads Settings</a>.
          </p>

          <h3>Google Analytics</h3>
          <p>
            We use Google Analytics to understand how visitors use our Service. Google Analytics collects
            information anonymously and reports website trends without identifying individual visitors.
          </p>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            Game data is automatically deleted after 30 days. Analytics data is retained according to our
            analytics provider's retention policies (typically 26 months for Google Analytics).
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            PhenoGuessr is intended for educational use and does not knowingly collect personal information
            from children under 13. If you are a parent or guardian and believe your child has provided
            personal information to us, please contact us so we can delete it.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>
            Depending on your location, you may have the following rights:
          </p>
          <ul>
            <li>Access the information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Opt out of marketing communications</li>
            <li>Withdraw consent for data processing</li>
          </ul>
        </section>

        <section>
          <h2>International Data Transfers</h2>
          <p>
            Your information may be transferred to and processed in countries other than your country of
            residence. These countries may have different data protection laws. By using our Service, you
            consent to such transfers.
          </p>
        </section>

        <section>
          <h2>Security</h2>
          <p>
            We implement reasonable security measures to protect your information. However, no method of
            transmission over the internet is 100% secure. We cannot guarantee absolute security of your
            data.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted on this page with
            an updated "Last Updated" date. Continued use of the Service after changes constitutes acceptance
            of the updated policy.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or how we handle your information, please
            contact us through the feedback form on our website.
          </p>
        </section>

        <div className="cta-section">
          <button className="primary-button" onClick={() => navigate('/')}>
            Back to Game
          </button>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
